import gql from "graphql-tag";
import { useQuery } from "react-apollo-hooks";

export const usePortfolioGallery = () => {
  const GET_ALL_GALLERY_DATA = gql`
    {
      getAllGalleryData {
        category
        description
        short_description
        location
        rep_group
        hotspot {
          content {
            addInfo
            display_type
            left
            product {
              image
              name
              sku
            }
            top
          }
          hotspot_id
          image
          name
        }
        id
        image
        name
        skuList
        position
      }
    }
  `;

  const { data, loading } = useQuery(GET_ALL_GALLERY_DATA, {
    variables: "portfolio_gallery",
    fetchPolicy: "cache-first",
  });

  return { data, loading };
};
